module.exports = __webpack_public_path__ + "img/stu_avatar_3.a02aa4ca.jpg";